import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import checkNotIcon from '../../../../../../../assetss/img/checkNotIcon.svg'
import './index.scss'

const AcceptMeetTime = ({ date }) => (
  <Grid className='avtorRequestMessageAceptWrapper'>
    <Grid className='avtorRequestMessageAcept'>
      <img className='checkIcon' src={checkNotIcon} />
      <Typography className='newTextBox'>
        You have accepted meeting <span className='textColorAccept'>{date}</span>. Google Meet link will be active just before the meeting.
      </Typography>
    </Grid>
  </Grid>
)

export default AcceptMeetTime
